import { isPublicLandingPath } from '../../shared/landingPageSeo.js';
import { localizedLandingHref } from '../../shared/landingDocumentUrl.js';
import { LandingLocaleState } from './landingLocaleState.js';
import { syncLandingDocumentMetadata } from './landingDocumentMetadata.js';

export const installLandingDocumentNavigation = () => {
  LandingLocaleState.restorePreferences();
  const anchors = new WeakMap<HTMLAnchorElement, { source: string; rendered: string }>();
  let scheduled = false;
  const update = () => {
    scheduled = false;
    if (!isPublicLandingPath(location.pathname)) return;
    const locale = LandingLocaleState.getInitialLocale();
    const audience = LandingLocaleState.getAudience();
    for (const anchor of document.querySelectorAll<HTMLAnchorElement>('#root a[href]')) {
      if (anchor.hasAttribute('download') || anchor.hasAttribute('hreflang')) continue;
      const current = anchor.getAttribute('href') ?? '';
      const previous = anchors.get(anchor);
      const source = previous && current === previous.rendered ? previous.source : current;
      const href = localizedLandingHref(source, locale, location.origin, audience);
      anchors.set(anchor, { source, rendered: href });
      if (current !== href) anchor.setAttribute('href', href);
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(update);
  };
  const changed = () => {
    syncLandingDocumentMetadata(LandingLocaleState.getInitialLocale());
    schedule();
  };
  window.addEventListener('location-changed', changed);
  window.addEventListener('popstate', changed);
  const observer = new MutationObserver(schedule);
  const root = document.getElementById('root');
  if (root) observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  schedule();
  return () => {
    observer.disconnect();
    window.removeEventListener('location-changed', changed);
    window.removeEventListener('popstate', changed);
  };
};
